import { render, staticRenderFns } from "./KusClientAccessTable.vue?vue&type=template&id=66f18608"
import script from "./KusClientAccessTable.vue?vue&type=script&lang=js"
export * from "./KusClientAccessTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports